if (!customElements.get('mewmora-countdown')) {
  class MewmoraCountdown extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      if (this.dataset.mode !== 'countdown') return;

      this.timer = this.querySelector('[data-countdown-timer]');
      this.liveRegion = this.querySelector('[data-countdown-live]');
      this.configuration = this.querySelector('[data-countdown-configuration]');
      this.days = this.querySelector('[data-countdown-days]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');
      this.deadline = this.parseDeadline(this.dataset.deadline);
      this.lastAnnouncementMinute = null;

      if (!this.deadline) {
        if (this.dataset.designMode === 'true') {
          this.timer.hidden = true;
          this.configuration.hidden = false;
        } else {
          this.hidden = true;
        }
        return;
      }

      this.handleVisibility = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.update();
          this.start();
        }
      };
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.update();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibility);
      this.initialized = false;
    }

    parseDeadline(value) {
      if (!value || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value.trim())) return null;
      const timestamp = Date.parse(value);
      return Number.isNaN(timestamp) ? null : timestamp;
    }

    start() {
      if (this.interval || this.finished || document.hidden) return;
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }

    update() {
      const remaining = Math.max(0, this.deadline - Date.now());
      if (remaining <= 0) {
        this.expire();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.days.textContent = String(days).padStart(2, '0');
      this.hours.textContent = String(hours).padStart(2, '0');
      this.minutes.textContent = String(minutes).padStart(2, '0');
      this.seconds.textContent = String(seconds).padStart(2, '0');

      const totalMinutes = Math.floor(totalSeconds / 60);
      if (this.lastAnnouncementMinute !== totalMinutes) {
        this.lastAnnouncementMinute = totalMinutes;
        this.liveRegion.textContent = `${days} days, ${hours} hours and ${minutes} minutes remaining.`;
      }
    }

    expire() {
      this.finished = true;
      this.stop();

      if (this.dataset.expiryBehavior === 'message' && this.dataset.expiredText) {
        const message = this.querySelector('.mewmora-countdown__message');
        if (message) {
          message.textContent = this.dataset.expiredText;
        } else {
          const newMessage = document.createElement('p');
          newMessage.className = 'mewmora-countdown__message';
          newMessage.textContent = this.dataset.expiredText;
          this.querySelector('.mewmora-countdown__inner')?.prepend(newMessage);
        }
        if (this.timer) this.timer.hidden = true;
        if (this.liveRegion) this.liveRegion.textContent = this.dataset.expiredText;
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('mewmora-countdown', MewmoraCountdown);
}
